<div class="container-fluid" id="{{helpElement.identifier}}">
  <div *ngIf="!isFormFieldHelp()" class="row mb-3" [ngClass]="{'pt-5 mt-2':!(showTitle && helpElement.name)}">
    <div *ngIf="showTitle && helpElement.name" class="col-11 pl-0">
      <h3 *ngIf="!indexLevel || indexLevel === 2" style="font-weight: 100;">
        <spam *ngIf="indexStr">{{ indexStr }} </spam>{{ helpElement.name }}
      </h3>
      <h4 *ngIf="indexLevel === 3" style="font-weight: 100;">
        <spam *ngIf="indexStr">{{ indexStr }} </spam>{{ helpElement.name }}
      </h4>
      <h5 *ngIf="indexLevel >= 4" style="font-weight: 100;">
        <spam *ngIf="indexStr">{{ indexStr }} </spam>{{ helpElement.name }}
      </h5>
    </div>
    <div class="col-1 pr-0">
      <button (click)="this.print()" class="btn btn-sm btn-outline-secondary ml-3 float-right print-btn"
        title="{{ 'General.print' | translate }}" type="button"><i class="fa fa-print"></i></button>
    </div>
    <p class="ml-2 mb-0 font-secondary font-italic d-none d-md-inline">{{ helpElement.shortDesc }}</p>
    <div class="col-12" *ngIf="helpElement.content">
      <div [ngClass]="getContainerEditorClass()">
        <div [ngClass]="getEditorClass()" [innerHtml]="sanitizedContent">
        </div>
      </div>
    </div>
    <div class="col-12 m-t-md" *ngIf="isExternalLink (helpElement)">
      <button pButton style="width: 80%;" type="button" icon="fas fa-play" class="btn btn-default"
        (click)="displayRef = true"></button>
    </div>
    <p-dialog [(visible)]="displayRef" [showHeader]="false" [closable]="true">
      <iframe width="560" height="315" [attr.src]="sanitizedExternalLink" frameborder="0" allowfullscreen></iframe>
    </p-dialog>
    <div class="col-12 m-t-md" *ngIf="isMultimediaContentLink(helpElement)">
      <button pButton style="width: 80%;" type="button" icon="fas fa-play" class="btn btn-default"
        (click)="displayVideo = true"></button>
    </div>
    <p-dialog [(visible)]="displayVideo" [showHeader]="false" [closable]="true">
      <video width="560" height="315" controls>
        <source [src]="sanitizedMultimediaContentLink" /> {{ 'GeneralHelp.elements.element.noVideo.message' | translate
        }}
      </video>
    </p-dialog>
  </div>
  <div *ngIf="isFormFieldHelp()" class="row">
    <div class="alert alert-info col-12 mt-1 ml-0 m-md ">
      <p><b>{{ elem.name }}</b></p>
      <div [ngClass]="getEditorClass()" [innerHtml]="sanitizedContent">
      </div>
    </div>
  </div>
  <div *ngIf=" this.userService.hasRoles('0,50')
        && this.userPrefs && this.userPrefs.mainViewPrefs && this.userPrefs.mainViewPrefs.showHelpTags;"
    class="alert alert-warning row">
    <div class="col-12"><span>Grupo: </span><span>{{helpElement.group}}</span></div>
    <div class="col-12"> <span>Identificador entrada: </span><span>{{helpElement.identifier}}</span></div>
    <div class="col-12"> <span>Perfiles: </span><span>{{helpElement.profiles}}</span></div>
  </div>
</div>
<!--  var printContents = document.getElementById(this.section).innerHTML;


  <video width="640" height="480">
  	<source src="video.mp4" type="video/mp4">
  	<source src="video.webm" type="video/webm">
  	<source src="video.ogv" type="video/ogg">
  	<img src="imagen.png" alt="Vídeo no soportado">
  	Este navegador no soporta contenido multimedia.
  </video>

-->